import { Component, Inject, OnInit } from '@angular/core';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from '../../../services/users.service';

enum Status {
    Default = 'Default',
    Pending = 'Pending',
    Error = 'Error',
}

@Component({
    selector: 'app-avatar-dialog',
    templateUrl: './avatar-dialog.component.html',
    styleUrls: ['./avatar-dialog.component.scss'],
})
export class AvatarDialogComponent implements OnInit {
    status: Status = Status.Default; // Control UI
    imageChangedEvent: any = '';
    errorDescriptionKey: string;

    constructor(
        private userService: UsersService,
        public dialogRef: MatDialogRef<AvatarDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { avatar: string }
    ) {}

    ngOnInit(): void {}

    fileChangeEvent(event: any): void {
        this.status = Status.Pending;
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.data.avatar = event.base64;
        this.status = Status.Default;
    }

    loadImageFailed() {
        this.handleError(true);
    }

    saveAvatar(): void {
        this.status = Status.Pending;
        const avatar = base64ToFile(this.data.avatar);
        this.userService.createAvatar(avatar).subscribe(
            (response) => {
                this.status = Status.Default;
                this.closeDialog(response.blobName + '?' + new Date().getTime());
            },
            () => this.handleError()
        );
    }

    deleteAvatar(): void {
        this.status = Status.Pending;
        this.userService.deleteAvatar().subscribe(
            () => {
                this.status = Status.Default;
                this.closeDialog('');
            },
            () => this.handleError()
        );
    }

    closeDialog(blobUrl?: string): void {
        this.dialogRef.close(blobUrl);
    }

    private handleError(formatError?: boolean) {
        this.status = Status.Error;
        this.imageChangedEvent = undefined;
        this.errorDescriptionKey = formatError
            ? 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.ERROR.INVALID_FORMAT'
            : 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.ERROR.GENERAL_ERROR';
    }
}
